import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../../../../store/store';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import WorkplaceSelection from './WorkplaceSelection';

loadDOMComponent({
	selector: 'react-workplace-selection',
	callback: ({ container, context }: any) => {
		const linkSelect = container.getAttribute('linkSelect') || null;

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<WorkplaceSelection linkSelect={linkSelect} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
